import i18n from "@/locales";

export const clearSwal = {
  title: i18n.t("view.commons.swal.clear.title")
  , text: i18n.t("view.commons.swal.clear.text")
  , type: i18n.t("view.commons.swal.clear.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , reverseButtons: true
  , showCancelButton: true
};

export const registroTalentoSwal = {
  title: i18n.t("view.commons.swal.registroTalentoSwal.title")
  , text: i18n.t("view.commons.swal.registroTalentoSwal.text")
  , type: i18n.t("view.commons.swal.registroTalentoSwal.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , reverseButtons: true
  , showCancelButton: true
};

export const tokenTalentoSwal = {
  title: i18n.t("view.commons.swal.tokenTalentoSwal.title")
  , text: i18n.t("view.commons.swal.tokenTalentoSwal.text")
  , type: i18n.t("view.commons.swal.tokenTalentoSwal.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , reverseButtons: true
  , showCancelButton: false
};



// WEBPACK FOOTER //
// ./src/constants/sweet-alerts.js